export const OOTB_AGENTS_BY_PRODUCT = {
	'atlassian-studio': [
		'jsm_service_triage_agent',
		'product_requirements_guide_agent',
		'customer_insights_agent',
	],
	jira: ['readiness_checker_agent', 'jira_theme_analyzer_agent', 'bug_report_assistant_agent'],
	'jira-service-management': [
		'jsm_service_triage_agent',
		'ops_guide_agent',
		'bug_report_assistant_agent',
	],
	confluence: [
		'product_requirements_guide_agent',
		'customer_insights_agent',
		'transcript_insights_reporter_agent',
	],
	default: [
		'jsm_service_triage_agent',
		'product_requirements_guide_agent',
		'customer_insights_agent',
	],
} as const;
